import {FC} from 'react';
import AddContract from '../../../components/AddContract';

const AddContractPage: FC = () => {
  return (
    <div>
      <AddContract />
    </div>
  );
};

export default AddContractPage;
